/**
 * Application Version
 *
 * DEPLOYMENT: Update this version alongside package.json
 * This file exists to avoid JSON import issues in SvelteKit SSR
 */

export const APP_VERSION = '0.3.302';
